module.exports = __webpack_public_path__ + "img/mace.7e324fd1.png";